import { SerializableObject } from '../../common-react/core';

import { CustomsInfo } from './customs-info.do';
import { Parcel } from './parcel.do';
import { Party } from './party.do';
import { ShipmentDeliveryServiceExtra } from './shipment-delivery-service-extra.do';
import { ShipmentDeliveryService } from './shipment-delivery-service.do';

/**
 * DTO Object for representing a shipment registration
 *
 * NOTE: ShipmentRegistrationOrganizationForm should be used for authenticated users, but none of
 *       the features are implemented, so we use its base class.
 *
 * @see mobiz-posturinn-extension:Posturinn.Extension.Models.DTO.ShipmentRegistrationForm
 * @see mobiz-posturinn-extension:Posturinn.Extension.Models.DTO.ShipmentRegistrationOrganizationForm
 */
export class ShipmentRegistrationForm extends SerializableObject {
  public recipient: Party;
  public sender: Party;
  public deliveryService: ShipmentDeliveryService;
  public selectedDeliveryLocation: string;
  public customsInfo: CustomsInfo;
  public numberOfParcels: number;
  public recipientPaysShippingFee: boolean;
  public parcels: Parcel[];
  public deliverTo: string;
  public chargeSenderCard: boolean;

  public asRequestBody(): string {
    const clonedValue = this.clone();
    // tslint:disable:no-unsafe-any
    if (Array.isArray(clonedValue.deliveryService.extraServices)) {
      // NOTE: The ShipmentDeliveryServiceExtra.options uses double serialization on the backend.
      clonedValue.deliveryService.extraServices = clonedValue.deliveryService.extraServices
        .map((extraService: ShipmentDeliveryServiceExtra) => extraService.asRequestBodyPart());
    }
    // tslint:enable:no-unsafe-any
    return JSON.stringify(clonedValue);
  }
}
